export default "__VITE_ASSET__DWM6yHcx__"